// extracted by mini-css-extract-plugin
module.exports = {"closeButton":"styles_closeButton__27CWp"};